import React, {useState,useEffect} from 'react';
import {Card,CardBody,Row,Col} from "reactstrap";
import {InputLabel,Select,TextField,FormControl} from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import { useForm} from "react-hook-form";
import {FormAutocomplete, FormInput} from "_components/FormElements/FormInput";
import { commonService } from '_services/common.service';
import { Spinner} from 'views/Hoc/Spinner';
import { history } from '_helpers/history';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { couponFormSchema } from '../profile/validation';
import { ToastsContainer, ToastsStore } from 'react-toasts';

const Couponform = (props) => {

  const [state, setState] = useState({
      
    planOptions : [{id:1,name:"Free"},{id:7,name:"LITE"},{id:2,name:"STARTER"},{id:5,name:"PRO"},{id:4,name:"ADVANCED"},{id:3,name:"TRIAL"}],
    planValue : [],
    typeOptions : [{id:2,name:"VENDOR"},{id:3,name:"DISTRIBUTOR"},{id:4,name:"RETAILER"}],
    typeValue : [],
    subTypeOptions : [{id:1,name:"New"},{id:2,name:"Renewal"},{id:3,name:"UpGrade"}],
    subTypeValue : [],
    statusOptions : [{id:"1",name:"Active"},{id:'0',name:"InActive"}],
    statusValue : [],
    periodOptions : [{id:1,name:"Month"},{id:2,name:"Year"}],
    periodValue : [],
    discountOptions : [{id:1,name:"Amount"},{id:2,name:"Percentage"}],
    discountValue : [],                
    couponDesc:'',
    couponCode:'',
    couponOfferValue:'',
    userThreshold:'',
    usageThreshold:'',
    fromDate:new Date(),        
    dateto:new Date(),        
  });



  const [errmsg, setErrmsg] = useState({      
    planValue : null,
    typeValue : null,
    subTypeValue : null,
    statusValue : null,
    periodValue : null,
    discountValue : null,                
    couponDesc:null, 
    couponCode:null, 
    couponOfferValue:null, 
    userThreshold:null, 
    usageThreshold:null, 
    fromDate:null,         
    dateto:null,      
  });

  const { register, handleSubmit, control, errors, watch, formState } = useForm({      
    mode:'all',  
   // resolver: yupResolver(couponFormSchema),
    //defaultValues: { couponDesc: 'aaaa', discountValue: {id:1, name:'Amount'}, genericType: '', type: 0 }
  });

  console.log('errors ===== ', errors)
  const watchAll = watch({couponDesc: ''});
  const {couponId,getCouponListing} = props;
  console.log('props ===== ', props)
  const [loading,setLoading] = useState(false);
  
   

      
    //const [fromDate, setFromDate] = React.useState(new Date('2014-08-18T21:11:54'));
    //const [toDate, setToDate] = React.useState(new Date('2014-08-18T21:11:54'));

    useEffect(() => {
      getSubscriptionPlans();
      setLoading(true);
      if(couponId > 0)
      {
        (async () => {
        //setLoading(true);      
        console.log('couponId =: ', couponId);       
        let coupons = await commonService.getServices('channelAdmin/channelCoupons/'+couponId);  
        
        state.couponDesc = coupons.data[0].couponDesc
        state.couponCode = coupons.data[0].couponCode
        setState({...state});
        setState({...state,
          planValue:[{id:coupons.data[0].subscriptionPlan.subscriptionPlanId,name:coupons.data[0].subscriptionPlan.subscriptionPlanType}],
          subTypeValue:{id:coupons.data[0].subscriptionType.subscriptionTypeId,name:coupons.data[0].subscriptionType.subscriptionType},
          typeValue:{id:coupons.data[0].channelType.channelTypeId,name:coupons.data[0].channelType.channelType},
          periodValue:[{id:coupons.data[0].subscriptionPeriodId,name:coupons.data[0].subscriptionPeriodId==1?'Month':'Year'}],
          statusValue:{id:coupons.data[0].isActive,name:coupons.data[0].isActive==1?'Active':'InActive'},
          discountValue:{id:+coupons.data[0].discountUnit,name:coupons.data[0].discountUnit==2?'Percentage':'Amount'},
          couponOfferValue:coupons.data[0].couponOfferValue,
          userThreshold:coupons.data[0].userThreshold,
          usageThreshold:coupons.data[0].usageThreshold,
          fromDate:coupons.data[0].fromDate,
          dateto:coupons.data[0].toDate,        
        });
        
       // console.log("coupons:",coupons.data[0]); 
       
        })();
        setLoading(false);
      }
      else
      {
       console.log('clearstate value:')
       
       state.planOptions = [{id:1,name:"Free"},{id:7,name:"LITE"},{id:2,name:"STARTER"},{id:5,name:"PRO"},{id:4,name:"ADVANCED"},{id:3,name:"TRIAL"}];
       state.typeOptions = [{id:2,name:"VENDOR"},{id:3,name:"DISTRIBUTOR"},{id:4,name:"RETAILER"}];
       state.subTypeOptions = [{id:1,name:"New"},{id:2,name:"Renewal"},{id:3,name:"UpGrade"}];
       state.statusOptions = [{id:"1",name:"Active"},{id:'0',name:"InActive"}];
       state.periodOptions = [{id:1,name:"Month"},{id:2,name:"Year"}];
       state.discountOptions = [{id:1,name:"Amount"},{id:2,name:"Percentage"}];
       state.planValue = [];
       state.typeValue = [];
       state.subTypeValue = [];
       state.statusValue = [];
       state.periodValue =  [];
       state.couponDesc = '';
       state.couponCode  = '';
       state.couponOfferValue  = '';
       state.userThreshold = '';
       state.usageThreshold  = '';
       state.fromDate  = new Date();        
       state.dateto  = new Date();       
       setState({ ...state });

        // setState({...state,planOptions : [{id:1,name:"Free"},{id:7,name:"LITE"},{id:2,name:"STARTER"},{id:5,name:"PRO"},{id:4,name:"ADVANCED"},{id:3,name:"TRIAL"}],
        // planValue : [],
        // typeOptions : [{id:2,name:"VENDOR"},{id:3,name:"DISTRIBUTOR"},{id:4,name:"RETAILER"}],
        // typeValue : [],
        // subTypeOptions : [{id:1,name:"New"},{id:2,name:"Renewal"},{id:3,name:"UpGrade"}],
        // subTypeValue : [],
        // statusOptions : [{id:"1",name:"Active"},{id:'0',name:"InActive"}],
        // statusValue : [],
        // periodOptions : [{id:1,name:"Month"},{id:2,name:"Year"}],
        // periodValue : [],
        // discountOptions :[{id:1,name:"Amount"},{id:2,name:"Percentage"}],
        // couponDesc:'',
        // couponCode:null,
        // couponOfferValue:null,
        // userThreshold:null,
        // usageThreshold:null,
        // fromDate:new Date(),        
        // dateto:new Date(),   
        // }); 
        setLoading(false);       
      }
    }, [couponId]); 
  
    const  getSubscriptionPlans = async() => {
      await commonService.getServices('/channelAdmin/getSubscriptionPlan').then(res=>{
          setState({...state,planOptions : res.data});
        });
    }
    const handleCopChange = input => e => { 
      
     // console.log('testing but not update',input , ' === ',  e.target.value)
    setState({...state, [input] : e.target.value});
     setErrmsg({...errmsg, [input]:null})         
     };

      
      const save = async() => {
        let err = null
        let eFields = {}
      //  console.log('xxxx=>:', state.couponOfferValue.match(/^[+-]?(\d+(\.\d*)?|\.\d+)$/))
        if(state.couponDesc.trim() == ''){
          err = true
         eFields.couponDesc = 'invalid'    
        } 
        if(state.couponCode.trim() == ''){
          err = true 
          eFields.couponCode = 'invalid' 
        }
        if(state.couponOfferValue.match(/^[+-]?(\d+(\.\d*)?|\.\d+)$/) == null){
          err = true    
           eFields.couponOfferValue = 'invalid' 
        }
         
         if(state.typeValue == ''){
           err = true 
           eFields.typeValue = 'invalid' 
         } 
         
         if(state.periodValue.length == 0){
           err = true  
           eFields.periodValue = 'invalid' 
         }  
         if(state.planValue.length == 0){
           err = true  
          eFields.planValue = 'invalid' 
        } 
        if(state.subTypeValue.length == 0){
          err = true          
          eFields.subTypeValue = 'invalid' 
        } 
        if(state.statusValue.length == 0){
          err = true         
          eFields.statusValue = 'invalid' 
        } 
        if(state.discountValue == null || state.discountValue.length == 0){
          err = true
          eFields.discountValue = 'invalid' 
        } else {
          if(state.discountValue.id == 2 && state.couponOfferValue > 100 ) {
            err = true
            eFields.couponOfferValue = 'invalidNumber'
          }
        }
        if(state.fromDate == '' || state.fromDate == undefined){
          err = true          
          eFields.fromDate = 'invalid' 
        } 
        if(state.dateto == '' || state.dateto == undefined){
          err = true          
          eFields.dateto = 'invalid' 
        }
        if(state.dateto >  state.fromDate){
          err = true          
          eFields.dateto = 'invalidGreaterDate' 
        } 


      //  console.log(err, 'error exist =>:', state.dateto)

        setErrmsg(eFields) 
        if(err == null ){
                
        let data={
        isActive:state.statusValue.id,
        subscriptionTypeId:+state.subTypeValue.id,
        channelTypeId:+state.typeValue.id,                 
        discountUnit:+state.discountValue.id,
        couponOfferValue:+state.couponOfferValue,
        userThreshold:+state.userThreshold,
        usageThreshold:+state.usageThreshold,
        couponDesc:state.couponDesc,
        couponCode:state.couponCode,
        fromDate:state.fromDate,
        toDate:state.dateto,
        }
        console.log('data listing == ', data);
        if(couponId==0)
        {
          Object.assign(data,{subscriptionPlans:state.planValue.map(x => x.id),
            subscriptionPeriods:state.periodValue.map(x => x.id)});
        }
        else
        {
          Object.assign(data,{ subscriptionPlanId:+state.planValue[0].id,
            subscriptionPeriodId:+state.periodValue[0].id})
        }
        
        setLoading(true);   
        if(couponId==0){
          try{
            let resp = await commonService.postService(data,'channelAdmin/addCoupon').then(res => {
              console.log('res =: ', res)
            });  
                
            closeDrawer();     
            getCouponListing();
          } catch(error) {
            if (error.response && error.response.status === 422) {
            //  console.log('Unprocessable Entity:', error.response.data[0].errors.property +' : '+error.response.data[0].errors[0].message);
              ToastsStore.error(error.response.data[0].property +' : ' + error.response.data[0].errors[0].message);
              setLoading(false);       
            } else {
                console.log('Error:', error.message);
            }
          }
        } else {
          await commonService.putService('channelAdmin/channelCoupons/'+couponId,data); 
          setLoading(false);        
          closeDrawer();   
          getCouponListing();
        } 
       }
       
      }    

      
      const handleFromDate = (date) => {        
        state.fromDate=date;
        setState({...state,fromDate:state.fromDate})
        //setFromDate(date);
      };

      const handleToDate = (date) => {        
        state.dateto=date;
        setState({...state,dateto:state.dateto})
        //setToDate(date);
      };

      const handleChangeSelect = (input,value) => {       
          setState({...state, [input]:value});  
          setErrmsg({...errmsg, [input]:null})
      }

      const [showDrawer,setshowDrawer]=useState(false);
      
      const closeDrawer =()=>{
        props.onClose();
        setshowDrawer(false);
      }

    return (
      
        <div>    
        <ToastsContainer position="top_right" autoClose={5000} store={ToastsStore} />   
        {loading? <Spinner />: (          
            <Card id='Coupon'>
                <CardBody>
                <form className="coupon-form" noValidate autoComplete="off" onSubmit={handleSubmit(save)}>
                    <Row>
                        <Col lg="6" className="mt-4">
                        <div className="form-group">
                        <FormInput
                          id="couponDesc"
                          type="text"
                          name="couponDesc"
                          label="Coupon Desc *"
                        //  label="First Name *"
                        //  register={register}
                          defaultValue={state.couponDesc}
                        //  error={errors.couponDesc}
                          value={state.couponDesc }
                          onChange={handleCopChange('couponDesc')}
                        />
                        {errmsg.couponDesc != null && <span className='errMsg'>  Enter Value for Coupon Desc</span>}
                        
                        </div>
                        </Col>
                        <Col lg="6" className="mt-4">
                        

                          <FormInput
                          id="couponCode"
                          type="text"
                          name="couponCode"
                          label="Coupon Code"
                        //  label="First Name *"
                        //  register={register}
                          defaultValue={state.couponCode}
                          error={errors.couponCode}
                          value={state.couponCode}
                          onChange={handleCopChange('couponCode')}
                        />
                    {errmsg.couponCode != null && <span className='errMsg'>  Enter Value for Coupon Code</span>}
                        
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="6" className="mt-4">
                        
                        <FormInput
                          id="couponOfferValue"
                          type="text"
                          name="couponOfferValue"
                          label="Coupon Offer Value"
                        //  register={register}
                          defaultValue={state.couponOfferValue}
                          error={errors.couponOfferValue}
                          value={state.couponOfferValue}
                          onChange={handleCopChange('couponOfferValue')}
                        />
{errmsg.couponOfferValue != null && <span className='errMsg'>  Please Enter valid numeric value for Coupon Offer Value</span>}


{ errmsg.couponOfferValue == 'invalidNumber' && <span className='errMsg'>  Percentage offer value should not greater than 100</span>}
                       
                        </Col>

                        <Col lg="6" className="mt-4">
                        <FormControl variant="outlined">
                        <FormAutocomplete
                        id="discountValue"
                        name="discountValue"
                        options={state.discountOptions}
                        label="Coupon Discount Unit"
                        input='discountValue'
                        errMessage={'Please Enter Coupon Discount Unit'}
                        value={state.discountValue}
                        defaultValue={state.discountValue}
                        handleChangeSelect={handleChangeSelect}
                        control={control}  
                        disableCloseOnSelect
                        blurOnSelect
                        getOptionSelected={(options, value) => options.name === value.name}
                        />
                        {errmsg.discountValue == 'invalid' && 
                        <span className='errMsg'>  Enter Value for Coupon Discount Value</span>}

                          </FormControl>
                        </Col>
                    </Row>



                    <Row>
                        <Col lg="6" className="mt-4">
                        <span>Coupon From Date</span>
                        <div className="awd-date">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                disableToolbar
                                variant="inline"
                                format="MM/dd/yyyy"
                                margin="normal"
                                id="datefrom"
                                name="datefrom"
                                error={errors.datefrom}
                                //label="Coupon From Date"
                                value={state.fromDate}
                                onChange={handleFromDate}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                              />
                        </MuiPickersUtilsProvider>
                        </div>
                         {errmsg.fromDate != null && 
                        <span className='errMsg'>  Enter Value for From Date</span>
                        }
                        </Col>
                        <Col lg="6" className="mt-4">
                        <span>Coupon To Date</span>
                        <div className="awd-date">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                disableToolbar
                                variant="inline"
                                format="MM/dd/yyyy"
                                margin="normal"
                                id="dateto"
                                name="dateto"
                                error={errors.dateto}
                                // label="Coupon To Date"
                                value={state.dateto}
                                defaultValue={state.dateto}
                                onChange={handleToDate}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                              />
                        </MuiPickersUtilsProvider>
                        </div>
                        {errmsg.dateto != null && 
                        <span className='errMsg'>  Enter Value for To Date</span>
                        }

                        {
                          errmsg.invalidGreaterDate && 
                           <span className='errMsg'> Offer To date Must be greater than from date</span>
                        }
                        </Col>
                    </Row>

                    <Row>
                        <Col lg="6" className="mt-4">
                        <FormControl variant="outlined">
                        <FormAutocomplete
                        id="statusValue"
                        name="statusValue"
                        label="Coupon Active/Inactive"
                        options={state.statusOptions}
                        placeholder="Coupon Active/Inactive"
                        input='statusValue'
                        errMessage={'Please Select Coupon Active/Inactive'}
                        //error={!errors.subplan || state.subplan.length ?false:true}
                        value={state.statusValue}
                        //error={errors.statusValue}
                        defaultValue={state.statusValue}
                        handleChangeSelect={handleChangeSelect}
                        control={control}     
                      //  register={register}                 
                        //multiple
                        disableCloseOnSelect
                        blurOnSelect
                        getOptionSelected={(options, value) => options.name === value.name}
                        />
                        
                            </FormControl>
                            {errmsg.statusValue != null && 
                        <span className='errMsg'>  Enter Value for Active Status</span>
                        }
                        </Col>
                        <Col lg="6" className="mt-4">
                        <FormControl variant="outlined">
                        <FormAutocomplete
                        id="subTypeValue"
                        name="subTypeValue"
                        label="Coupon subscription Type"
                        options={state.subTypeOptions}
                        placeholder="Coupon subscription Type"
                        input='subTypeValue'
                        errMessage={'Please Select Coupon subscription Type'}
                        //error={errors.subTypeValue}
                        //error={!errors.subplan || state.subplan.length ?false:true}
                        value={state.subTypeValue}
                        defaultValue={state.subTypeValue}
                        handleChangeSelect={handleChangeSelect}
                        control={control}  
                      //  register={register}                    
                        //multiple
                        disableCloseOnSelect
                        blurOnSelect
                        getOptionSelected={(options, value) => options.name === value.name}
                        />                        
                        </FormControl>
                         {errmsg.subTypeValue != null && 
                        <span className='errMsg'>  Please Select Coupon subscription Type</span>
                        }
                        </Col>
                    </Row>

                    <Row>
                        <Col lg="6" className="mt-4"> 
                        <FormControl variant="outlined">
                        <FormAutocomplete
                        id="typeValue"
                        name="typeValue"
                        label="Coupon Channel Type"
                        options={state.typeOptions}
                        placeholder="Coupon Channel Type"
                        input='typeValue'
                        errMessage={'Please Select Coupon Channel Type'}
                        //error={!errors.subplan || state.subplan.length ?false:true}
                        value={state.typeValue}
                       // error={errors.typeValue}
                        defaultValue={state.typeValue}
                        handleChangeSelect={handleChangeSelect}
                        control={control}  
                       // register={register}                    
                        //multiple
                        disableCloseOnSelect
                        blurOnSelect
                        getOptionSelected={(options, value) => options.name === value.name}
                        />                        
                        </FormControl>
                           {errmsg.typeValue != null && 
                        <span className='errMsg'>  Please Select Coupon Channel Type</span>
                        }
                        </Col>
                        <Col lg="6" className="mt-4">

                        <FormControl variant="outlined">

                        <FormAutocomplete
                        id="planValue"
                        name="planValue"
                        label="Select Subscription Plan"
                        options={state.planOptions}
                        placeholder="Select Subscription Plan"
                        input='planValue'
                        errMessage={'Please Select Subscription Plan'}
                        //error={!errors.subplan || state.subplan.length ?false:true}
                        value={state.planValue}
                        //error={errors.planValue}
                        defaultValue={state.planValue}
                        handleChangeSelect={handleChangeSelect}
                        control={control}   
                      //  register={register}                   
                        multiple
                        disableCloseOnSelect
                        blurOnSelect
                        getOptionSelected={(options, value) => options.name === value.name}
                        />
                        </FormControl>
                         {errmsg.planValue != null && 
                        <span className='errMsg'>  Please Select Subscription Plan</span>
                        }
                        </Col>
                    </Row>

                    <Row>
                        <Col lg="6" className="mt-4">
                        <FormInput
                          id="userThreshold"
                          type="text"
                          name="userThreshold" 
                          label="Please Enter Usage userThreshold"
                        //  register={register}                         
                          error={errors.userThreshold}
                          value={state.userThreshold}
                          defaultValue={state.userThreshold}
                          onChange={handleCopChange('userThreshold')}
                        />                       
                        {errmsg.userThreshold != null && 
                        <span className='errMsg'>   Please Enter valid numeric value for Usage userThreshold</span>
                        }
                        </Col>
                        <Col lg="6" className="mt-4">
                       
                        <FormInput
                          id="usageThreshold"
                          type="text"
                          name="usageThreshold"
                          label="Please Enter Usage Threshold"
                        //  register={register}    
                          error={errors.usageThreshold}
                        //  errMessage={'Please Enter Usage Threshold'}
                          value={state.usageThreshold}
                          defaultValue={state.usageThreshold}
                          onChange={handleCopChange('usageThreshold')}
                        />
                        {errmsg.usageThreshold != null && 
                        <span className='errMsg'>   Please Enter valid numeric value for  Usage Threshold</span>
                        }
                        </Col>
                    </Row>

                    <Row>
                    <Col lg="12" className="mt-4">
                        
                        <FormAutocomplete
                        id="SubPeriod"
                        name="SubPeriod"
                       // label="Coupon Subscription Period"
                        options={state.periodOptions}
                        label="Coupon Subscription Period"
                        input='periodValue'
                        errMessage={'Please Select Coupon Subscription Period'}
                        //error={!errors.subplan || state.subplan.length ?false:true}
                        value={state.periodValue}
                        defaultValue={state.periodValue}
                        handleChangeSelect={handleChangeSelect}
                        control={control}                 
                        multiple
                        disableCloseOnSelect
                        blurOnSelect
                        getOptionSelected={(options, value) => options.name === value.name}
                        />
                        {errmsg.periodValue != null && 
                        <span className='errMsg'>  Please Select Coupon Subscription Period</span>
                        }
                        {/* <FormControl variant="outlined">
                        <FormAutocomplete
                        id="periodValue"
                        name="periodValue"
                        label="Coupon Subscription Period"
                        options={state.periodOptions}
                        placeholder="Coupon Subscription Period"
                        input='periodValue'
                        error={errors.periodValue}  
                      //  register={register}     
                     //   errMessage={'Please Select Coupon Subscription Period'}
                        //error={!errors.subplan || state.subplan.length ?false:true}
                        value={state.periodValue}
                        defaultValue={state.periodValue}
                        handleChangeSelect={handleChangeSelect}
                        control={control}                 
                        multiple
                        disableCloseOnSelect
                        blurOnSelect
                        getOptionSelected={(options, value) => options.name === value.name}
                        />
                        
                            </FormControl> */}
                        </Col>
                    </Row>
                    <div className="text-center mt-4">
            <button type="submit"  className="btn btn-primary" >Save</button>
            <button onClick={e => {e.preventDefault(); closeDrawer()}}  className="btn btn-warning" >Cancel</button>
          </div> 
                </form>
                </CardBody>
            </Card>
            )};
        </div>
                
    );
};

export default Couponform;